import apiClient from "@/services/apiClient";

export async function registerUser(payload) {
  const { data } = await apiClient.post("/auth/register", payload);
  return data;
}

export async function loginUser(payload) {
  const { data } = await apiClient.post("/auth/login", payload);
  return data;
}

// Second login step for accounts with two-factor authentication enabled -- loginUser() above
// returns { two_factor_required: true, email } instead of establishing a session when this is
// needed; call this with the 6-digit code emailed to the user to actually log in.
export async function verifyTwoFactorLogin(payload) {
  const { data } = await apiClient.post("/auth/verify-two-factor", payload);
  return data;
}

export async function logoutUser() {
  const { data } = await apiClient.post("/auth/logout");
  return data;
}

export async function requestPasswordReset(payload) {
  const { data } = await apiClient.post("/auth/forgot-password", payload);
  return data;
}

export async function resetPassword(payload) {
  const { data } = await apiClient.post("/auth/reset-password", payload);
  return data;
}

export async function getCurrentUser() {
  const { data } = await apiClient.get("/auth/me");
  return data;
}

export async function verifyEmail(payload) {
  const { data } = await apiClient.post("/auth/verify-email", payload);
  return data;
}

export async function resendVerificationCode(payload) {
  const { data } = await apiClient.post("/auth/resend-verification", payload);
  return data;
}
